import api from './api';

import { type Product } from '../types';

interface ProductData {
  nombre: string;
  descripcion: string;
  precio: number;
  sku: string;
  stock: number;
  categoria: string;
  es_visible: boolean;
  es_comprable: boolean;
  imagen_url: string;
}

const productService = {
  getProducts: async (comercioKey: string): Promise<Product[]> => {
    const response = await api.get<Product[]>(`/comercios/${comercioKey}/productos`);
    return response.data;
  },

  createProduct: async (comercioKey: string, productData: ProductData): Promise<Product> => {
    const response = await api.post<Product>(`/comercios/${comercioKey}/productos`, productData);
    return response.data;
  },

  updateProduct: async (comercioKey: string, productId: number, productData: Partial<ProductData>): Promise<Product> => {
    const response = await api.put<Product>(`/comercios/${comercioKey}/productos/${productId}`, productData);
    return response.data;
  },

  deleteProduct: async (comercioKey: string, productId: number): Promise<void> => {
    await api.delete(`/comercios/${comercioKey}/productos/${productId}`);
  },
};

export default productService;